import styled from 'styled-components';

export const FooterContainer = styled.div`
    height: 50px;
    background: #0c0c0c;
    color: #fff;
    text-align: center;
`